import React from 'react'

export default function DomainDisabledIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M22.0002 17.15L20.0002 15.15V6.99998H11.8502L10.0002 5.14998V2.99998H7.8502L5.8502 0.999976H12.0002V4.99998H22.0002V17.15ZM20.5002 21.3L18.1502 19H2.0002V2.79998L0.700195 1.49998L2.1002 0.0999756L21.9002 19.9L20.5002 21.3ZM4.0002 17H6.0002V15H4.0002V17ZM4.0002 13H6.0002V11H4.0002V13ZM4.0002 8.99998H6.0002V6.99998H4.0002V8.99998ZM8.0002 17H10.0002V15H8.0002V17ZM8.0002 13H10.0002V11H8.0002V13ZM12.0002 17H16.1502L14.1502 15H12.0002V17ZM18.0002 11H16.0002V8.99998H18.0002V11Z'
        fill='currentcolor'
      />
    </svg>
  )
}
